<template>
  <div class="sankey-chart"></div>
</template>

<script>
import * as d3 from "d3";
import * as d3sankey from "d3-sankey";

export default {
  props: ["budgetChoice", "quantitySelected", "yearSelected"],
  data() {
    return {
      // currentBudget: this.budgetChoice,
      // currentBudget:
      //   "Бюджет Ємільчинської селищної об'єднаної територіальної громади",
      jsonSankey: [],
      chartActive: false,
      currentCategory: undefined,
      colNameMapper: {
        кількості: "tot_contracts",
        суми: "tot_value",
      },
    };
  },
  methods: {
    makeChart() {
      var vueContext = this;
      // set the dimensions and margins of the graph
      var margin = { top: 10, right: 0, bottom: 10, left: 0 },
        // width = 350 - margin.left - margin.right,
        width = d3.select(".sankey-chart").node().getBoundingClientRect().width,
        height = 300 - margin.top - margin.bottom;

      // format variables
      var formatNumber = d3.format(",.0f"), // zero decimal places
        format = function (d) {
          return formatNumber(d);
        };
      // color = d3.scaleOrdinal(d3.schemeCategory10);

      // append the svg object to the body of the page
      var svg = d3
        .select(".sankey-chart")
        .append("svg")
        .attr("width", width + margin.left + margin.right)
        .attr("height", height + margin.top + margin.bottom)
        .append("g")
        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

      // Set the sankey diagram properties
      var sankey = d3sankey
        .sankey()
        .nodeWidth(36)
        .nodePadding(5)
        .size([width, height]);

      // var path = sankey.links();

      // load the data
      var graph = sankey(this.currentSankey);
      // console.log(this.currentSankey);

      // add in the links
      svg
        .append("g")
        .selectAll(".link")
        .data(graph.links)
        .enter()
        .append("path")
        // .attr("class", "link")
        .attr("class", (d) => {
          if (d.target.name === "Інше") {
            return "link non-active-other";
          } else {
            return "link cat";
          }
        })
        .attr("d", d3sankey.sankeyLinkHorizontal())
        .attr("stroke-width", function (d) {
          return d.width;
        })
        .on("mouseover", function (event, d) {
          div.transition().duration(200).style("opacity", 0.9);
          div.html(
            "<p>" +
              d.target.name +
              "</p>" +
              // "<br>" +
              "<p>" +
              format(d.value).replaceAll(",", " ") +
              (vueContext.quantitySelected === "суми"
                ? " грн"
                : " контрактів") +
              "</p>"
          );
          // .style("left", event.pageX + "px")
          // .style("top", event.pageY - 28 + "px");
        })
        .on("mouseout", function () {
          div.transition().duration(500).style("opacity", 0);
        });

      // // add the link titles
      // link.append("title").text(function (d) {
      //   return d.source.name + " → " + d.target.name + "\n" + format(d.value);
      // });

      // tooltip
      var div = d3
        .select(".sankey-chart")
        .append("div")
        .attr("class", "tooltip")
        .style("opacity", 0)
        .style("width", width + "px");

      // add in the nodes
      var node = svg
        .append("g")
        .selectAll(".node")
        .data(graph.nodes)
        .enter()
        .append("g")
        .attr("class", (d) => {
          if (d.index) {
            if (d.name === "Інше") {
              return "node non-active-other";
            } else {
              return "node cat";
            }
          } else {
            return "node init";
          }
        });

      // add the rectangles for the nodes
      node
        .append("rect")
        .attr("x", function (d) {
          return d.x0;
        })
        .attr("y", function (d) {
          return d.y0;
        })
        .attr("height", function (d) {
          return d.y1 - d.y0;
        })
        .attr("width", sankey.nodeWidth())
        .on("mouseover", function (event, d) {
          div.transition().duration(200).style("opacity", 0.9);
          div.html(
            "<p>" +
              d.name +
              "</p>" +
              // "<br>" +
              "<p>" +
              format(d.value).replaceAll(",", " ") +
              (vueContext.quantitySelected === "суми"
                ? " грн"
                : " контрактів") +
              "</p>"
          );
          // .style("left", event.pageX + "px")
          // .style("top", event.pageY - 28 + "px");
        })
        .on("mouseout", function () {
          div.transition().duration(500).style("opacity", 0);
        });
      // .style("fill", function (d) {
      //   return (d.color = color(d.name.replace(/ .*/, "")));
      // })
      // .style("stroke", function (d) {
      //   return d3.rgb(d.color).darker(2);
      // })
      // .append("title")
      // .text(function (d) {
      //   return (
      //     d.name +
      //     "\n" +
      //     format(d.value) +
      //     (vueContext.quantitySelected === "суми" ? " грн" : "")
      //   );
      // });

      // eslint-disable-next-line no-unused-vars
      d3.selectAll(".node.cat").on("click", (event, node) => {
        // console.log(event.target);

        this.currentCategory = node.name;

        this.$emit("sendCategory", this.currentCategory);

        d3.selectAll(".cat rect")
          .style("stroke", "#A3ADD6")
          .style("stroke-width", "1px");

        d3.select(event.target)
          .style("stroke", "#6E7DBD")
          .style("stroke-width", "2px");
      });

      d3.selectAll(".link.cat").on("click", (event, link) => {
        // console.log(event.target);
        // console.log(link.target.name);

        this.currentCategory = link.target.name;

        this.$emit("sendCategory", this.currentCategory);

        d3.selectAll(".cat rect")
          .style("stroke", "#A3ADD6")
          .style("stroke-width", "1px");

        d3.selectAll(".cat rect")
          .filter((d) => d.name === link.target.name)
          .style("stroke", "#6E7DBD")
          .style("stroke-width", "2px");

        // d3.select(event.target)
        //   .style("stroke", "#6E7DBD")
        //   .style("stroke-width", "2px");
      });

      // // add in the title for the nodes
      // node
      //   .append("text")
      //   .attr("x", function (d) {
      //     return d.x0 - 6;
      //   })
      //   .attr("y", function (d) {
      //     return (d.y1 + d.y0) / 2;
      //   })
      //   .attr("dy", "0.35em")
      //   .attr("text-anchor", "end")
      //   .text(function (d) {
      //     return d.name;
      //   })
      //   .filter(function (d) {
      //     return d.x0 < width / 2;
      //   })
      //   .attr("x", function (d) {
      //     return d.x1 + 6;
      //   })
      //   .attr("text-anchor", "start");
    },
  },
  mounted() {
    this.jsonSankey = require("@/assets/data/data_sankey_full.json");

    this.makeChart();
    this.chartActive = !this.chartActive;
  },
  computed: {
    currentBudget() {
      return this.budgetChoice;
    },
    currentCol() {
      return this.colNameMapper[this.quantitySelected];
    },
    currentSankey() {
      let jsonSelected = this.jsonSankey.filter(
        (row) =>
          row["budgetName"] === this.currentBudget &&
          row["year"] === this.yearSelected
      );

      let nodes = [];

      nodes.push({
        node: 0,
        name: jsonSelected[0]["budgetName"],
      });

      for (let i = 0; i < jsonSelected.length; i++) {
        const element = jsonSelected[i]["cat_name3"];

        nodes.push({
          node: i + 1,
          name: element,
        });
      }

      let links = [];

      for (let i = 0; i < jsonSelected.length; i++) {
        const element = jsonSelected[i][this.currentCol];

        links.push({
          source: 0,
          target: i + 1,
          value: element,
        });
      }

      return {
        nodes: nodes,
        links: links,
      };
    },
  },
  watch: {
    budgetChoice() {
      if (this.budgetChoice) {
        // this.currentBudget = this.budgetChoice;

        if (this.chartActive) {
          d3.select("svg").remove();
          d3.select(".tooltip").remove();

          this.makeChart();
        } else {
          this.makeChart();
        }
      }
    },
    quantitySelected() {
      if (this.quantitySelected) {
        // this.currentBudget = this.budgetChoice;

        if (this.chartActive) {
          d3.select("svg").remove();
          d3.select(".tooltip").remove();

          this.makeChart();
        } else {
          this.makeChart();
        }
      }
    },
    yearSelected() {
      if (this.yearSelected) {
        // this.currentBudget = this.budgetChoice;

        if (this.chartActive) {
          d3.select("svg").remove();
          d3.select(".tooltip").remove();

          this.makeChart();
        } else {
          this.makeChart();
        }
      }
    },
  },
};
</script>

<style lang="scss">
.node rect {
  // cursor: move;
  fill-opacity: 0.9;
  shape-rendering: crispEdges;
}
.node.init {
  fill: #6e7dbd;
}
.node.cat {
  cursor: pointer;
  fill: #a3add6;
  &:hover {
    opacity: 0.8;
  }
}
.node.non-active-other {
  fill: #a3add6;
}

.node text {
  pointer-events: none;
  text-shadow: 0 1px 0 #fff;
}

.link {
  fill: none;
  stroke: #000;
  stroke-opacity: 0.2;
  &.cat {
    cursor: pointer;
  }
  &.cat:hover {
    stroke-opacity: 0.5;
  }
}

.tooltip {
  margin-top: 16px;
  height: 72px;
  p:first-child {
    margin-bottom: 4px;
    color: #6e7dbd;
  }
}
</style>